export interface MenuItem {
  title: string;
  key: string;
  isVisible: boolean;
  link?: string;
  external?: boolean
}

export const MENU_ITEMS: MenuItem[] = [
  {
    title: 'Home',
    key: 'home',
    isVisible: true,
    link: '/',
  },
  {
    title: 'Blog',
    key: 'blog',
    isVisible: true,
    link: '/blog',
  },
  {
    title: 'Liste',
    key: 'list',
    isVisible: true,
    link: '/liste',
  },
  {
    title: 'Le nostre proposte',
    key: 'proposals',
    isVisible: true,
    link: '/speciali',
    // external: true
  },
  {
    title: 'Contattaci',
    key: 'contact_us',
    isVisible: true,
    link: '/contatti',
  },
];
